import { debounce } from 'lodash';
import { useEffect, useMemo, useState } from 'react';

import { Box } from 'ui/Layout';

import { LISTENER_EVENT_DEBOUNCE_MS } from '../../constants';

const PageScrollableShadows: React.FC = () => {
  const [background, setBackground] = useState('');

  // Debounced function to set the background to avoid excessive re-renders
  const debouncedSetBackground = useMemo(
    () => debounce(setBackground, LISTENER_EVENT_DEBOUNCE_MS),
    [setBackground]
  );

  useEffect(() => {
    const handleUpdateBackground = () => {
      const gradients: string[] = [];

      // Add top gradient if there's content above the current viewport
      if (window.scrollY > 0) {
        gradients.push(
          'radial-gradient(farthest-side at 50% 0, black, transparent) center top'
        );
      }

      // Add bottom gradient if there's content below the current viewport
      if (window.scrollY < document.body.scrollHeight - window.innerHeight) {
        gradients.push(
          'radial-gradient(farthest-side at 50% 100%, black, transparent) center bottom'
        );
      }

      // Construct radial gradients background string
      debouncedSetBackground(gradients.join(', '));
    };

    // Initialize background state
    handleUpdateBackground();

    // Add event listeners
    window.addEventListener('scroll', handleUpdateBackground);
    window.addEventListener('resize', handleUpdateBackground);

    // Clean up the listeners
    return () => {
      window.removeEventListener('scroll', handleUpdateBackground);
      window.removeEventListener('resize', handleUpdateBackground);
    };
  }, []);

  return (
    <Box
      background={background}
      backgroundRepeat="no-repeat"
      backgroundSize="100% 20px"
      opacity={0.3}
      pointerEvents="none"
      position="fixed"
      zIndex="overlay"
      top={0}
      left={0}
      w="100%"
      h="100%"
    />
  );
};

export default PageScrollableShadows;
